import styled from 'styled-components';

import { flexGap } from '@/shared/lib/helpers/flex-gag-polyfill.helper';
import { Spinner } from '@/shared/ui/spinner';

import { ButtonProps } from './button.types';

export const Button = styled.button<
	Required<Pick<ButtonProps, 'variant' | 'size' | 'withTooltip' | 'tooltip'>> & Pick<ButtonProps, 'padding'>
>`
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	border: none;
	outline: none;
	cursor: pointer;
	white-space: nowrap;
	border-radius: ${({ theme: { button } }) => button.radius};
	min-height: 37px;
	transition: ${({ theme: { transition } }) => transition.primary};
	padding: ${({ padding, theme: { button } }) => padding || button.padding.default};
	width: ${({ withTooltip, tooltip, size, theme: { button } }) =>
		withTooltip && tooltip ? button.size[size] : '100%'};
	max-width: ${({ size, theme: { button } }) => button.size[size]};
	${({ variant, theme: { button } }) => ({ ...button[variant] })};
	${({ theme: { button } }) => flexGap(button.iconGap)};

	& > svg {
		display: block;
	}

	@media ${({ theme: { media } }) => media.mobile} {
		padding: ${({ padding, theme: { button } }) => padding || button.padding.mobile};
	}
`;

export const ButtonSpinner = styled(Spinner)`
	height: auto;
	position: absolute;
	left: 10px;
`;
